import React, { useState, useEffect } from 'react';
import { IMAGES } from "../../../assets/images";
import { useFormik } from "formik";
import * as Yup from "yup";
import Footer from "../footer/footer"
import Header from "../header/header"
import { getTermsAndCondition, contactUs } from '../services';
import { useNavigate } from 'react-router-dom'
import { routerPath } from '../../navigation/path'
import { toast } from 'react-toastify';
import CustomButton from '../../components/button';


const validationS = Yup.object({
    firstName: Yup.string().required("First Name Is Required"),
    lastName: Yup.string().required("Last Name Is Required"),
    email: Yup.string().email("Invalid Email Format").required("Email Is Required"),
    phoneNumber: Yup.string()
        .length(10, "Phone number must be exactly 10 digits")
        .required("Phone number is required")
        .matches(/^[0-9]{10}$/),
    subject: Yup.string().required("Subject is required"),
    message: Yup.string().required("Message is required"),
});

const subjectLabels = {
    generalInquiry: "General Inquiry",
    subscriptionPurchase: "Subscription Purchase",
    codeRelated: "Code Related",
    others: "Others",
};

const ContectUs = () => {
    const navigate = useNavigate()
    const [ContactDetails, setContactDetails] = useState({});
    const [HTMLContent, setHTMLContent] = useState({});
    const [Loading, setLoading] = useState(false);

    useEffect(() => {
        getContactUsDetails();
    }, []);

    const getContactUsDetails = async () => {
        try {
            const res = await getTermsAndCondition('contact_us');
            if (res.data && res.data[0]) {
                console.log(res)
                setContactDetails(res.data[0]);
                if (res.data[0].content) {
                    const parsedContent = parseHtmlToJson(res.data[0].content);
                    setHTMLContent(parsedContent);
                }
            } else {
                console.error("Invalid response structure", res);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const parseHtmlToJson = (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        const jsonData = { email: '', contactNumber: '', address: '' };
        const paragraphs = div.querySelectorAll('p');
        paragraphs.forEach((p) => {
            const text = p.textContent.trim();
            if (text.startsWith('E-Mail:')) {
                jsonData.email = p.querySelector('a')?.textContent || '';
            } else if (text.startsWith('Contact Number:')) {
                jsonData.contactNumber = text.replace('Contact Number: ', '');
            } else if (text.startsWith('Address:')) {
                const addressText = text.replace('Address: ', '');
                jsonData.address += addressText;
            } else {
                jsonData.address += ` ${text}`;
            }
        });
        return jsonData;
    };

    const formik = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
            subject: '',
            message: '',
        },
        validationSchema: validationS,
        onSubmit: (values) => {
            const payload = {
                first_name: values.firstName,
                last_name: values.lastName,
                email: values.email,
                phone_number: values.phoneNumber,
                subject: subjectLabels[values.subject],
                message: values.message,
            };
            console.log(payload);
            submitDetails(payload);
            // toast.success(res.message)
        },
    });

    const submitDetails = async (payload) => {
        try {
            setLoading(true)
            const res = await contactUs(payload)
            console.log(res)
            setLoading(false)
            if (res.message) {
                toast.success(res.message)
                navigate(routerPath.home);
            }
        } catch (err) {
            setLoading(false)
            console.log(err)
            toast.error(err.response?.data?.message || err.message)
        }
    }

    return (
        <div className="bg-[#f1f1f1] ">
            <Header />
            <div className="w-[80%] m-auto ">
                <div className="py-5 ">
                    <h3 className="text-center text-[40px] font-bold">Contact Us</h3>
                    <p className="text-center mb-0">
                        Any question or remarks? Just write us a message!
                    </p>
                </div>
                <div className="grid lg:grid-cols-5 sm:grid-cols-1 bg-white p-3 rounded mb-5">
                    <div className="lg:col-span-2 sm:w-[100%] bg-blue-600 rounded p-4">
                        <div className="mb-5">
                            <h4 className="text-white mb-0 text-xl font-bold">
                                Contact Information
                            </h4>
                        </div>
                        <div className="flex mb-5 text-sm">
                            <img src={IMAGES.phoneCall} alt="" className="mr-3" />
                            <span className="text-white">
                                {HTMLContent.contactNumber}


                            </span>
                        </div>

                        <div className="flex mb-5 text-sm">
                            <img src={IMAGES.mail} alt="" className="mr-3" />
                            <span className="text-white">
                                {HTMLContent.email}
                            </span>
                        </div>
                        <div className="flex mb-5 text-sm">
                            <img src={IMAGES.locaiton} alt="" className="mr-3" />
                            <span className="text-white">
                                {HTMLContent.address}
                            </span>
                        </div>
                        <div className="flex">
                            <div className="bg-white h-[30px] w-[30px] p-[8px] rounded-[50%] mx-2">
                                <img src={IMAGES.insta} alt="" />
                            </div>
                            <div className="bg-white h-[30px] w-[30px] p-[8px] rounded-[50%] mx-2">
                                <img src={IMAGES.twit} alt="" />
                            </div>
                            <div className="bg-white h-[30px] w-[30px] p-[8px] rounded-[50%] mx-2">
                                <img src={IMAGES.game} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-span-3 p-5">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="flex flex-wrap mb-3">
                                <div className="lg:w-[50%] sm:w-[100%] p-2">
                                    <label htmlFor="firstName" className="block text-sm">
                                        First Name
                                    </label>
                                    <input
                                        type="text"
                                        id="firstName"
                                        name="firstName"
                                        className="w-[100%] border-b border-[#000] focus:border-b-2 focus:border-blue-600 focus:outline-none"
                                        value={formik.values.firstName}
                                        onChange={formik.handleChange}
                                    />
                                    {formik.errors.firstName && formik.touched.firstName && (
                                        <div className="text-red-500 text-xs">{formik.errors.firstName}</div>
                                    )}
                                </div>
                                <div className="lg:w-[50%] sm:w-[100%] p-2">
                                    <label htmlFor="lastName" className="block text-sm">
                                        Last Name
                                    </label>
                                    <input
                                        type="text"
                                        id="lastName"
                                        name="lastName"
                                        className="w-[100%] border-b border-[#000] focus:border-b-2 focus:border-blue-600 focus:outline-none"
                                        value={formik.values.lastName}
                                        onChange={formik.handleChange}
                                    />
                                    {formik.errors.lastName && formik.touched.lastName && (
                                        <div className="text-red-500 text-xs">{formik.errors.lastName}</div>
                                    )}
                                </div>
                                <div className="lg:w-[50%] sm:w-[100%] p-2">
                                    <label htmlFor="email" className="block text-sm">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        className="w-[100%] border-b border-[#000] focus:border-b-2 focus:border-blue-600 focus:outline-none"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                    />
                                    {formik.errors.email && formik.touched.email && (
                                        <div className="text-red-500 text-xs">{formik.errors.email}</div>
                                    )}
                                </div>
                                <div className="lg:w-[50%] sm:w-[100%] p-2">
                                    <label htmlFor="phoneNumber" className="block text-sm">
                                        Phone Number
                                    </label>
                                    <input
                                        type="tel"
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        className="w-[100%] border-b border-[#000] focus:border-b-2 focus:border-blue-600 focus:outline-none"
                                        value={formik.values.phoneNumber}
                                        onChange={formik.handleChange}
                                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                        maxLength="10"
                                    />
                                    {formik.errors.phoneNumber && formik.touched.phoneNumber && (
                                        <div className="text-red-500 text-xs">{formik.errors.phoneNumber}</div>
                                    )}
                                </div>
                            </div>
                            <div className="mb-3">
                                <p className="mb-2">Subject</p>
                                {Object.keys(subjectLabels).map((key) => (
                                    <div key={key} className="mb-2 mr-4 inline-block">
                                        <input
                                            type="radio"
                                            id={key}
                                            name="subject"
                                            value={key}
                                            checked={formik.values.subject === key}
                                            onChange={formik.handleChange}
                                        />
                                        <label htmlFor={key} className="ml-2">
                                            {subjectLabels[key]}
                                        </label>
                                    </div>
                                ))}
                                {formik.errors.subject && formik.touched.subject && (
                                    <div className="text-red-500 text-xs">{formik.errors.subject}</div>
                                )}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="message" className="block text-sm">
                                    Message
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    className="w-[100%] border-b border-[#000] focus:border-b-2 focus:border-blue-600 focus:outline-none"
                                    value={formik.values.message}
                                    onChange={formik.handleChange}
                                />
                                {formik.errors.message && formik.touched.message && (
                                    <div className="text-red-500 text-xs">{formik.errors.message}</div>
                                )}
                            </div>
                            <div className="text-center">
                                <CustomButton title={'Send Message'} type='submit' loader={Loading} />
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <Footer />

        </div>
    );
};


export default ContectUs